module.exports = __webpack_public_path__ + "img/paperplane2.bbd674a4.png";